import { getCiphersuiteFromName, getCiphersuiteImpl } from 'ts-mls';
/**
 * Cipher Suite und Envelope-Konstanten für Zone A.
 *
 * Die Wahl ist in [ADR-003a](../../../docs/adr/ADR-003a-mls-implementierung.md)
 * begründet: X25519 + AES-128-GCM + SHA-256 + Ed25519. Die Bibliothek kann auch
 * post-quanten-Suiten; die bleiben ungenutzt, weil sie größere Pakete und mehr
 * Rechenzeit auf alten Geräten bedeuten (Anf. 66) und „heute abfangen, später
 * entschlüsseln" für Familienchat nicht die treibende Sorge ist.
 */
export const SUITE_NAME = 'MLS_128_DHKEMX25519_AES128GCM_SHA256_Ed25519';
let cached = null;
/** Einmal aufbauen und wiederverwenden — die Initialisierung ist nicht billig. */
export function suite() {
    cached ??= getCiphersuiteImpl(getCiphersuiteFromName(SUITE_NAME));
    return cached;
}
/**
 * Rückgabetypen bewusst nicht annotiert: TextEncoder liefert
 * `Uint8Array<ArrayBuffer>`, eine eigene `Uint8Array`-Annotation wäre breiter
 * (`ArrayBufferLike`) und passte dann nicht mehr zu `BufferSource` — WebCrypto
 * verlangt genau den engeren Typ.
 */
export const utf8 = {
    encode: (s) => new TextEncoder().encode(s),
    decode: (b) => new TextDecoder().decode(b),
};
export const b64 = {
    encode(bytes) {
        let s = '';
        for (const byte of bytes)
            s += String.fromCharCode(byte);
        return btoa(s);
    },
    decode(text) {
        const roh = atob(text);
        const out = new Uint8Array(roh.length);
        for (let i = 0; i < roh.length; i++)
            out[i] = roh.charCodeAt(i);
        return out;
    },
};
/**
 * Macht aus einem `Uint8Array` einen Puffer, den WebCrypto akzeptiert.
 *
 * Hintergrund: Seit TypeScript 5.7 ist `Uint8Array` über den Puffertyp
 * generisch. Eine Sicht auf einen `SharedArrayBuffer` erfüllt `BufferSource`
 * nicht — deshalb lehnt der Compiler jeden Wert ab, dessen Herkunft er nicht
 * kennt. Die Kopie kostet bei Schlüsselmaterial nichts und ist ehrlicher als
 * ein Cast, der das Problem nur verdeckt.
 */
export function alsPuffer(bytes) {
    const out = new Uint8Array(bytes.length);
    out.set(bytes);
    return out;
}
//# sourceMappingURL=suite.js.map